import { Component, Input, OnInit } from '@angular/core';
import { EIconPath } from 'src/app/project/shared/enums/icons.enum';
import { TPushNotification } from '../../notification.model';
import { getNotificationReasonText } from '../../utils/notification-reason';

@Component({
    selector: 'pp-notification-description',
    templateUrl: './notification-description.component.html',
    styleUrls: ['../notification.component.scss'],
    standalone: false
})
export class NotificationDescriptionComponent implements OnInit {
  @Input() ppNotification: TPushNotification<string>;

  notificationReason: string;
  EIconPath = EIconPath;

  constructor() {}

  ngOnInit(): void {
    this.notificationReason = getNotificationReasonText(this.ppNotification.notificationReason);
  }
}
